import { useSelector } from "react-redux";

const PurchaseReports = () => {
  return (
    <>
      {/* <h4 style={{ "text-align": "center", "padding-bottom": "20px" }}>Purchase Reports</h4> */}
      <div className="iframe-div">
        <iframe
          title="Report Section"
          width="600"
          height="373.5"
          src="https://app.powerbi.com/reportEmbed?reportId=4a1562e7-8bdd-4684-9a14-847e306a1694&autoAuth=true&ctid=ba784b85-00b3-4cc1-963f-f0e2efaad20d"
          frameborder="0"
          allowFullScreen="true"
        ></iframe>
      </div>
    </>
  );
};

export default PurchaseReports;
